import React, { Component } from "react";



export default class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
  }

  render() {

    return (
      <div>
          <br></br>
          <h1>NOT FOUND</h1>
          <br></br>
          <p>Contents of this page will arrive soon.</p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/pages/NotFound.js